/*
 * pogi-sticky-cta — floating "Build your cleanup kit" pill.
 *
 * 1) position:fixed only anchors to the viewport if NO ancestor establishes a
 *    containing block (transform / filter / contain / will-change — created by
 *    view-transitions, scroll-reveal, etc.). If one does, the fixed pill gets
 *    trapped at its section near the page bottom — which is why it only appeared
 *    down low / on the way back up. So we relocate the element to <body>.
 * 2) Visibility is IntersectionObserver-driven: show once the hero scrolls out of
 *    view, hide as the final-CTA / footer arrives — identical down or up.
 * The button carries [data-open-kit-builder]; this only toggles visibility.
 */
class PogiStickyCta extends HTMLElement {
  connectedCallback() {
    // Escape any transformed/contained ancestor so position:fixed tracks the viewport.
    if (this.parentElement !== document.body) {
      document.body.appendChild(this); // re-fires connectedCallback with <body> as parent
      return;
    }

    this._pastHero = false;
    this._nearStop = false;
    this._update = () => {
      this.classList.toggle('is-visible', this._pastHero && !this._nearStop);
    };

    const hero = document.querySelector('.pogi-hhero, .pogi-hero, .pogi-subhero');
    const stop = document.querySelector('.pogi-fcta') || document.querySelector('.pogi-foot');

    if ('IntersectionObserver' in window && hero) {
      this._heroIO = new IntersectionObserver((e) => {
        this._pastHero = !e[0].isIntersecting;
        this._update();
      }, { threshold: 0 });
      this._heroIO.observe(hero);

      if (stop) {
        this._stopIO = new IntersectionObserver((e) => {
          this._nearStop = e[0].isIntersecting;
          this._update();
        }, { rootMargin: '0px 0px 60px 0px' });
        this._stopIO.observe(stop);
      }
    } else {
      // fallback: px threshold on the window scroll
      const t = parseInt(this.dataset.threshold, 10) || 700;
      this._onScroll = () => { this._pastHero = window.scrollY > t; this._update(); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
    }

    this._update();
  }

  disconnectedCallback() {
    if (this._heroIO) this._heroIO.disconnect();
    if (this._stopIO) this._stopIO.disconnect();
    if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
  }
}

if (!customElements.get('pogi-sticky-cta')) {
  customElements.define('pogi-sticky-cta', PogiStickyCta);
}
